import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import { handleDeleteItem } from "./HandleDeleteFunction";
import { setWorkHistorys } from "../../Slices/employeeslice";
import Modal from "../../blueplanitUtils/Modal";
import { DatePickerField, SelectInput } from "../../blueplanitUtils/InputField";
import { useFormHandler } from "../../blueplanitUtils/EmployeeSubmitFun";
import { handleClose } from "./HandleClosePop/handleclose";
import { handleKeyDown } from "../../blueplanitUtils/DatePickerAutoformate";
import { getOptionsByPath, useNestedDropdownHandler } from "../../utilsdata";
import { WORK_HISTORY, PROCESS_HANDLED, ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT, BASIC_INFO, SHIFT_TIMINGS, TECHNOLOGIES, SALES_CHANNEL } from "../../Dropdownmanager";
export const WorkModelPopUp = () => {
    const { handleSubmit } = useFormHandler()
    const dispatch = useDispatch()
 
    const [workHistoryRecord, setWorkHistory] = useState([]);
    const History = useSelector((state) => state.employee.workHistory);
    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
    const [isFormValid, setIsFormValid] = useState(false);
    const [workHistoryErrors, setWorkHistoryErrors] = useState({});
    const Departmentoptions = getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT]);
    const { selectedId, handleChange, reset } = useNestedDropdownHandler(Departmentoptions);
    const handleDepartmentChange = (value, index) => {
        handleChange(value);
        handleHistoryRecordChange(index, {
            target: {
                name: "department",
                value: value,
            },
        });
    };
 
    useEffect(() => {
        setWorkHistory(History)
    }, [History])
    const validateWorkHistory = (workHistory) => {
        const errors = {};
        const requiredFields = ["department", "designation", "shiftTimings", "from", "to"];
 
        // department-specific validation
        if (["IT", "Sales", "Operations"].includes(workHistory?.department?.toLowerCase())) {
            if (!workHistory.clientHandled || workHistory.clientHandled.length === 0) {
                errors.clientHandled = "Client Handled is required.";
            }
        }
 
        if (workHistory?.department?.toLowerCase() === "operations") {
            if (!workHistory.processHandled || !workHistory.processHandled.trim()) {
                errors.processHandled = "Process Handled is required.";
            }
        }
 
        requiredFields.forEach((field) => {
            const value = workHistory[field];
            if (!value || (typeof value === "string" && !value.trim())) {
                errors[field] = `${field.replace(/([A-Z])/g, " $1")} is required.`;
            }
        });
 
        return errors;
    };
 
 
 
 
    const handleHistoryRecordChange = (index, e) => {
        let name, value;
 
        if (e && e.target) {
            name = e.target.name;
            value = e.target.value;
        }
        else if (e && e instanceof Date) {
            name = e.name;
            value = e;
        } else {
            return;
        }
 
        const updatedWorkHistoryData = [...workHistoryRecord];
        updatedWorkHistoryData[index] = { ...updatedWorkHistoryData[index], [name]: value };
 
        setWorkHistory(updatedWorkHistoryData);
        const updatedErrors = { ...workHistoryErrors };
        const errors = validateWorkHistory(updatedWorkHistoryData[index]);
 
        if (Object.keys(errors).length > 0) {
            updatedErrors[index] = errors;
        } else {
            delete updatedErrors[index];
        }
        setWorkHistoryErrors(updatedErrors);
 
        const allFieldsValid = updatedWorkHistoryData.every((record, i) => Object.keys(updatedErrors[i] || {}).length === 0);
        setIsFormValid(allFieldsValid);
    };
 
    const addWorkHistory = () => {
        const newWorkHistory = {
            department: "",
            designation: "",
            clientHandled: "",
            processHandled: "",
            shiftTimings: "",
            from: "",
            to: "",
        };
 
        setWorkHistory((prev) => [...prev, newWorkHistory]);
        setIsFormValid(false);
    };
 
    const deleteWorkHistory = (index) => {
        handleDeleteItem(index, workHistoryRecord, setWorkHistory, workHistoryErrors, setWorkHistoryErrors, setIsFormValid);
    };
 
 
    const handleWorkHistorySubmit = async (e) => {
        e.preventDefault();
 
        const newErrors = { ...workHistoryErrors };
 
        workHistoryRecord.forEach((workHistory, index) => {
            const errors = validateWorkHistory(workHistory);
            if (Object.keys(errors).length > 0) {
                newErrors[index] = errors;
            }
        });
        setWorkHistoryErrors(newErrors);
 
        if (Object.keys(newErrors).length > 0) return;
        const noErrors = Object.keys(newErrors).length === 0;
        const formattedWorkHistoryData = workHistoryRecord?.map(({ __typename, ...workHistory }) => workHistory);
        const input = { workHistory: formattedWorkHistoryData }
        try {
            const val = await handleSubmit({
                noErrors,
                formValid: isFormValid,
                dataObj: input,
                action: "WorkHistory",
                ModalName: "WorkHistoryModalpopup",
                submitAction: "handleWorkHistoruSubmit",
            });
            if (val) {
                dispatch(setWorkHistorys(formattedWorkHistoryData));
                setIsFormValid(false)
            }
        }
        catch (error) {
 
        } finally {
            setIsFormValid(false);
        }
    };
    const clientOptions = useSelector(state => state.clients.clients);
    const activeClientOptions = clientOptions
        ?.filter(clientOption => clientOption?.status === "Active" || clientOption?.status === "active")
        .map(clientOption => ({
            label: clientOption?.clientName,
            value: clientOption?.clientName,
        }));
 
    const usedClient = workHistoryRecord
        ?.map(item => item.clientHandled)
        ?.flat();
 
    const remainingClientFields = activeClientOptions?.filter(
        field => !usedClient?.includes(field.value) || field.value === "Others"
    );
    const handleModalCloseWithDepartmentReset = () => {
        reset();
        handleClose(History, setWorkHistory, setWorkHistoryErrors, setIsFormValid);
    };
    return (
        <>
            <Modal
                id="work_history_modal_popup"
                title="Add Work History"
                handleSubmit={handleWorkHistorySubmit}
                handleModalClose={handleModalCloseWithDepartmentReset}
                isUserDataValid={false}
            >
                {workHistoryRecord?.map((record, index) => {
                    // 🔹 Get conditional visibility rules
                    const getFieldVisibility = (department) => {
                        switch (department) {
                            case "IT":
                                return { clientLabel: "Technologies", showClient: true, showProcess: false };
                            case "Sales":
                                return { clientLabel: "Sales Channel", showClient: true, showProcess: false };
                            case "HR & Admin":
                                return { clientLabel: "", showClient: false, showProcess: false };
                            case "Operations":
                                return { clientLabel: "Client Handled", showClient: true, showProcess: true };
                            default:
                                return { clientLabel: "Client Handled", showClient: true, showProcess: true };
                        }
                    };
 
                    const { clientLabel, showClient, showProcess } = getFieldVisibility(record?.department);
 
                    return (
                        <div key={index} className="card mb-3 shadow-sm">
                            <div className="card-body">
                                <h3 className="card-title d-flex justify-content-between align-items-center">
                                    Work History {index + 1}
                                    <Link
                                        to="#"
                                        className="delete-icon "
                                        onClick={() => deleteWorkHistory(index)}
                                    >
                                        <i className="fa-regular fa-trash-can" />
                                    </Link>
                                </h3>
                                <div className="row">
                                    {/* Department */}
                                    <div className="col-md-6 ">
                                        <SelectInput
                                            formControl={true}
                                            label="Department"
                                            required={true}
                                            options={Departmentoptions}
                                            error={workHistoryErrors[index]?.department}
                                            name="department"
                                            value={record?.department || ""}
                                            onChange={(value) => handleDepartmentChange(value, index)}
                                            style={{
                                                height: "100%",
                                                minHeight: "40px",
                                                lineHeight: "40px",
                                                border: "none",
                                            }}
                                        />
                                    </div>
 
                                    {/* Designation */}
                                    <div className="col-md-6 ">
                                        <SelectInput
                                            formControl={true}
                                            label="Designation"
                                            required={true}
                                            options={getOptionsByPath(NestedDatabucket, [
                                                ...[ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT],
                                                selectedId,
                                            ])}
                                            error={workHistoryErrors[index]?.designation}
                                            name="designation"
                                            value={record?.designation || ""}
                                            onChange={(e) =>
                                                handleHistoryRecordChange(index, {
                                                    target: {
                                                        name: "designation",
                                                        value: e,
                                                    },
                                                })
                                            }
                                            style={{
                                                height: "100%",
                                                minHeight: "40px",
                                                lineHeight: "40px",
                                                border: "none",
                                            }}
                                        />
                                    </div>
 
                                    {/* Client Handled → conditional */}
                                    {showClient && (
                                        <div className="col-md-6 ">
                                            <SelectInput
                                                mode="multiple"
                                                required={true}
                                                formControl={true}
                                                label={clientLabel}
                                                name="clientHandled"
                                                value={record?.clientHandled || []}
                                                onChange={(selectedValues) =>
                                                    handleHistoryRecordChange(index, {
                                                        target: {
                                                            name: "clientHandled",
                                                            value: selectedValues,
                                                        },
                                                    })
                                                }
                                                options={
                                                    record?.department === "IT"
                                                        ? getOptionsByPath(NestedDatabucket, [
                                                            WORK_HISTORY,
                                                            TECHNOLOGIES,   // 👈 dept constant for IT
                                                        ])
                                                        : record?.department === "Sales"
                                                            ? getOptionsByPath(NestedDatabucket, [
                                                                WORK_HISTORY,
                                                                SALES_CHANNEL,  // 👈 dept constant for Sales
                                                            ])
                                                            : remainingClientFields
                                                }
 
                                                style={{
                                                    height: "100%",
                                                    minHeight: "40px",
                                                    lineHeight: "40px",
                                                    border: "none",
                                                }}
                                                error={workHistoryErrors[index]?.clientHandled}
                                            />
 
                                        </div>
                                    )}
 
                                    {/* Process Handled → conditional */}
                                    {showProcess && (
                                        <div className="col-md-6 ">
                                            <SelectInput
                                                formControl={true}
                                                required={true}
                                                style={{
                                                    height: "100%",
                                                    minHeight: "40px",
                                                    lineHeight: "40px",
                                                    border: "none",
                                                }}
                                                label="Process Handle"
                                                name="processHandled"
                                                value={record?.processHandled || ""}
                                                onChange={(e) =>
                                                    handleHistoryRecordChange(index, {
                                                        target: {
                                                            name: "processHandled",
                                                            value: e,
                                                        },
                                                    })
                                                }
                                                options={getOptionsByPath(NestedDatabucket, [
                                                    WORK_HISTORY,
                                                    PROCESS_HANDLED,
                                                ])}
                                                error={workHistoryErrors[index]?.processHandled}
                                            />
                                        </div>
                                    )}
 
                                    {/* Shift Timings */}
                                    <div className="col-md-6 ">
                                        <SelectInput
                                            formControl={true}
                                            required={true}
                                            style={{
                                                height: "100%",
                                                minHeight: "40px",
                                                lineHeight: "40px",
                                                border: "none",
                                            }}
                                            label="Shift Timings"
                                            name="shiftTimings"
                                            value={record?.shiftTimings || ""}
                                            onChange={(e) =>
                                                handleHistoryRecordChange(index, {
                                                    target: {
                                                        name: "shiftTimings",
                                                        value: e,
                                                    },
                                                })
                                            }
                                            options={getOptionsByPath(NestedDatabucket, [
                                                BASIC_INFO,
                                                SHIFT_TIMINGS,
                                            ])}
                                            error={workHistoryErrors[index]?.shiftTimings}
                                        />
                                    </div>
 
                                    {/* From */}
                                    <div className="col-md-6 ">
                                        <DatePickerField
                                            formcontrol="form-control"
                                            required={true}
                                            label="From"
                                            value={record?.from ? dayjs(record?.from) : null}
                                            onChange={(date) => {
                                                const isoString = date ? date.toISOString() : null;
                                                handleHistoryRecordChange(index, {
                                                    target: {
                                                        name: "from",
                                                        value: isoString,
                                                    },
                                                });
                                            }}
                                            disabledDate={(current) =>
                                                record?.to ? current.isAfter(dayjs(record?.to).endOf("day")) : false
                                            }
                                            onKeyDown={handleKeyDown}
                                            format="DD/MM/YYYY"
                                            style={{ width: "100%" }}
                                            getPopupContainer={(trigger) => trigger.parentElement}
                                            onFocus={(e) => e.preventDefault()}
                                            autoFocus={false}
                                            error={workHistoryErrors[index]?.from}
                                        />
                                    </div>
 
                                    {/* To */}
                                    <div className="col-md-6 ">
                                        <DatePickerField
                                            formcontrol="form-control"
                                            required={true}
                                            label="To"
                                            value={record?.to ? dayjs(record?.to) : null}
                                            onChange={(date) => {
                                                const isoString = date ? date.toISOString() : null;
                                                handleHistoryRecordChange(index, {
                                                    target: {
                                                        name: "to",
                                                        value: isoString,
                                                    },
                                                });
                                            }}
                                            disabledDate={(current) =>
                                                record?.from ? current.isBefore(dayjs(record?.from).startOf("day")) : false
                                            }
                                            onKeyDown={handleKeyDown}
                                            format="DD/MM/YYYY"
                                            style={{ width: "100%" }}
                                            getPopupContainer={(trigger) => trigger.parentElement}
                                            onFocus={(e) => e.preventDefault()}
                                            error={workHistoryErrors[index]?.to}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
 
                <div className="add-more">
                    <Link to="#" onClick={addWorkHistory}>
                        <i className="fa-solid fa-plus-circle" /> Add More
                    </Link>
                </div>
            </Modal>
        </>
    );
 
}
 